module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG67cf3d67063604fca8d4c3452743dcb8.67cf3d67.png";